import { ScrollContainer } from "@memorang/ui";
import { ProethicaPrinciplesTabs } from "./ProethicaPrinciplesTabs";
import { useProethicaPrinciples } from "./data";

export const ProethicaPrinciplesScreen = () => {
	const principles = useProethicaPrinciples();

	return (
		<ScrollContainer maxWidth="sm" contentContainerStyle={{ padding: 24 }}>
			<ProethicaPrinciplesTabs principles={principles} />
		</ScrollContainer>
	);
};
